
export class TableFactory<T extends object>{
    constructor() {
    }

    Init(
        data: T[],
        selector: string,
        columnDefs: ColumnDefsSettings[],
        buttonsSettings: ButtonsSettings = false,
        dom: string | undefined = undefined,
        select: SelectSettings = false): TableInterface<T> {
        return new Table<T>(data, selector, columnDefs, buttonsSettings, dom, select);
    }


}

export interface ColumnDefsSettings extends DataTables.ColumnDefsSettings {

}

export type ButtonsSettings = boolean | string[] | DataTables.ButtonsSettings | DataTables.ButtonSettings[] | undefined
export type SelectSettings = boolean | string | DataTables.SelectSettings


export interface TableInterface<T> {
    GetSelectedData(): T[];
    Clear()

    Reset(data: T[])

    DeleteRow(row: HTMLTableRowElement)

    UpdateRow(row: HTMLTableRowElement, data: T)

    GetData(row: HTMLTableRowElement): T

    AddRow(data: T)

    Draw()
}

class Table<T extends object> implements TableInterface<T> {
    $table: HTMLTableElement;
    jqueryTable: DataTables.Api;
    constructor(
        private data: T[],
        private selector: string,
        private columnDefs: DataTables.ColumnDefsSettings[],
        buttonsSettings: ButtonsSettings = false,
        dom: string | undefined = undefined,
        select: SelectSettings = false

    ) {
        var config = {
            select: select,
            columnDefs: columnDefs,
            data: data,
            buttons: buttonsSettings,
        }
        if (dom != undefined)
            config["dom"] = dom;

        this.jqueryTable = $(selector).DataTable(config);
    }

    GetSelectedData(): T[] {
        let data: T[] = this.jqueryTable.rows(".selected").data().toArray();
        return data;
    }
    ;

    public Clear() {
        this.jqueryTable.clear();
    }

    public Reset(data: T[]) {
        this.Clear();
        this.jqueryTable.rows.add(data);

    }

    public UpdateRow(row: HTMLTableRowElement, data: T) {
        this.jqueryTable.row(row).data(data);
    }

    public GetData(row: HTMLTableRowElement): T {
        let data = <T>this.jqueryTable.row(row).data();
        return data;
    }

    public AddRow(data: T) {
        this.jqueryTable.row.add(data);
    }

    public DeleteRow(row: HTMLTableRowElement){
        this.jqueryTable.row(row).remove()
    }

    public Draw() {
        this.jqueryTable.draw(false);
    }
}